import React, { createContext, useContext, useState, useEffect, PureComponent, isValidElement } from 'react';
import classNames from 'classnames';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

var BaseIconSVG = function (_a) {
    var className = _a.className, children = _a.children, height = _a.height, width = _a.width, iconType = _a.iconType, rest = __rest(_a, ["className", "children", "height", "width", "iconType"]);
    return (React.createElement("svg", __assign({ className: classNames('nhsuk-icon', iconType, className), xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", "aria-hidden": "true", height: height, width: width }, rest), children));
};
BaseIconSVG.defaultProps = {
    height: 32,
    width: 32,
};
var ArrowLeft = function (props) { return (React.createElement(BaseIconSVG, __assign({ iconType: "nhsuk-icon__arrow-left" }, props),
    React.createElement("path", { d: "M4.1 12.3l2.7 3c.2.2.5.2.7 0 .1-.1.1-.2.1-.3v-2h11c.6 0 1-.4 1-1s-.4-1-1-1h-11V9c0-.2-.1-.4-.3-.5h-.2c-.1 0-.3.1-.4.2l-2.7 3c0 .2 0 .4.1.6z" }))); };
var ArrowRight = function (props) { return (React.createElement(BaseIconSVG, __assign({ iconType: "nhsuk-icon__arrow-right" }, props),
    React.createElement("path", { d: "M19.6 11.66l-2.73-3A.51.51 0 0 0 16 9v2H5a1 1 0 0 0 0 2h11v2a.5.5 0 0 0 .32.46.39.39 0 0 0 .18 0 .52.52 0 0 0 .37-.16l2.73-3a.5.5 0 0 0 0-.64z" }))); };
var ArrowRightCircle = function (props) { return (React.createElement(BaseIconSVG, __assign({ iconType: "nhsuk-icon__arrow-right-circle" }, props),
    React.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
    React.createElement("path", { d: "M12 2a10 10 0 0 0-9.95 9h11.64L9.74 7.05a1 1 0 0 1 1.41-1.41l5.66 5.65a1 1 0 0 1 0 1.42l-5.66 5.65a1 1 0 0 1-1.41 0 1 1 0 0 1 0-1.41L13.69 13H2.05A10 10 0 1 0 12 2z" }))); };
var ChevronLeft = function (props) { return (React.createElement(BaseIconSVG, __assign({ iconType: "nhsuk-icon__chevron-left" }, props),
    React.createElement("path", { d: "M8.5 12c0-.3.1-.5.3-.7l5-5c.4-.4 1-.4 1.4 0s.4 1 0 1.4L10.9 12l4.3 4.3c.4.4.4 1 0 1.4s-1 .4-1.4 0l-5-5c-.2-.2-.3-.4-.3-.7z" }))); };
var ChevronRight = function (props) { return (React.createElement(BaseIconSVG, __assign({ iconType: "nhsuk-icon__chevron-right" }, props),
    React.createElement("path", { d: "M15.5 12a1 1 0 0 1-.29.71l-5 5a1 1 0 0 1-1.42-1.42l4.3-4.29-4.3-4.29a1 1 0 0 1 1.42-1.42l5 5a1 1 0 0 1 .29.71z" }))); };
var Close = function (props) { return (React.createElement(BaseIconSVG, __assign({ iconType: "nhsuk-icon__close" }, props),
    React.createElement("path", { d: "M13.41 12l5.3-5.29a1 1 0 1 0-1.42-1.42L12 10.59l-5.29-5.3a1 1 0 0 0-1.42 1.42l5.3 5.29-5.3 5.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l5.29-5.3 5.29 5.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42z" }))); };
var Cross = function (props) { return (React.createElement(BaseIconSVG, __assign({ iconType: "nhsuk-icon__cross" }, props),
    React.createElement("path", { d: "M17 18.5c-.4 0-.8-.1-1.1-.4l-10-10c-.6-.6-.6-1.6 0-2.1.6-.6 1.5-.6 2.1 0l10 10c.6.6.6 1.5 0 2.1-.3.3-.6.4-1 .4z" }),
    React.createElement("path", { d: "M7 18.5c-.4 0-.8-.1-1.1-.4-.6-.6-.6-1.5 0-2.1l10-10c.6-.6 1.5-.6 2.1 0 .6.6.6 1.5 0 2.1l-10 10c-.3.3-.6.4-1 .4z" }))); };
var SmallEmdash = function (_a) {
    var height = _a.height, width = _a.width, rest = __rest(_a, ["height", "width"]);
    return (React.createElement(BaseIconSVG, __assign({ iconType: "nhsuk-icon__emdash", height: height || 1, width: width || 16 }, rest),
        React.createElement("path", { d: "M0 0h16v1H0z" })));
};
var Emdash = function (_a) {
    var className = _a.className, height = _a.height, width = _a.width, rest = __rest(_a, ["className", "height", "width"]);
    return (React.createElement(BaseIconSVG, __assign({ iconType: "nhsuk-icon__emdash", height: height || 1, width: width || 19 }, rest),
        React.createElement("path", { d: "M0 0h19v1H0z" })));
};
var Minus = function (props) { return (React.createElement(BaseIconSVG, __assign({ iconType: "nhsuk-icon__minus" }, props),
    React.createElement("circle", { cx: "12", cy: "12", r: "10" }),
    React.createElement("path", { fill: "none", stroke: "#fff", strokeLinecap: "round", strokeMiterlimit: "10", strokeWidth: "2", d: "M8 12h8" }))); };
var Plus = function (props) { return (React.createElement(BaseIconSVG, __assign({ iconType: "nhsuk-icon__minus" }, props),
    React.createElement("circle", { cx: "12", cy: "12", r: "10" }),
    React.createElement("path", { fill: "none", stroke: "#fff", strokeLinecap: "round", strokeMiterlimit: "10", strokeWidth: "2", d: "M12 8v8M8 12h8" }))); };
var Search = function (props) { return (React.createElement(BaseIconSVG, __assign({ iconType: "nhsuk-icon__search" }, props),
    React.createElement("path", { d: "M19.71 18.29l-4.11-4.1a7 7 0 1 0-1.41 1.41l4.1 4.11a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42zM5 10a5 5 0 1 1 5 5 5 5 0 0 1-5-5z" }))); };
var Tick = function (props) { return (React.createElement(BaseIconSVG, __assign({ iconType: "nhsuk-icon__tick" }, props),
    React.createElement("path", { strokeWidth: "4", strokeLinecap: "round", stroke: "#007f3b", fill: "none", d: "M18.4 7.8l-8.5 8.4L5.6 12" }))); };

var Icons = /*#__PURE__*/Object.freeze({
    __proto__: null,
    BaseIconSVG: BaseIconSVG,
    ArrowLeft: ArrowLeft,
    ArrowRight: ArrowRight,
    ArrowRightCircle: ArrowRightCircle,
    ChevronLeft: ChevronLeft,
    ChevronRight: ChevronRight,
    Close: Close,
    Cross: Cross,
    SmallEmdash: SmallEmdash,
    Emdash: Emdash,
    Minus: Minus,
    Plus: Plus,
    Search: Search,
    Tick: Tick
});

var ActionLink = function (_a) {
    var children = _a.children, _b = _a.asElement, Component = _b === void 0 ? 'a' : _b, className = _a.className, rest = __rest(_a, ["children", "asElement", "className"]);
    return (React.createElement("div", { className: "nhsuk-action-link" },
        React.createElement(Component, __assign({ className: classNames('nhsuk-action-link__link', className) }, rest),
            React.createElement(ArrowRightCircle, null),
            React.createElement("span", { className: "nhsuk-action-link__text" }, children))));
};

var BackLink = function (_a) {
    var children = _a.children, className = _a.className, _b = _a.asElement, Component = _b === void 0 ? 'a' : _b, rest = __rest(_a, ["children", "className", "asElement"]);
    return (React.createElement("div", { className: "nhsuk-back-link" },
        React.createElement(Component, __assign({ className: classNames('nhsuk-back-link__link', className) }, rest),
            React.createElement(ChevronLeft, null),
            children)));
};

var Container = function (_a) {
    var className = _a.className, fluid = _a.fluid, rest = __rest(_a, ["className", "fluid"]);
    return (React.createElement("div", __assign({ className: classNames({ 'nhsuk-width-container': !fluid }, { 'nhsuk-width-container-fluid': fluid }, className) }, rest)));
};

var Col = function (_a) {
    var className = _a.className, width = _a.width, rest = __rest(_a, ["className", "width"]);
    return (React.createElement("div", __assign({ className: classNames("nhsuk-grid-column-" + width, className) }, rest)));
};

var Row = function (_a) {
    var className = _a.className, rest = __rest(_a, ["className"]);
    return (React.createElement("div", __assign({ className: classNames('nhsuk-grid-row', className) }, rest)));
};

var Item = function (_a) {
    var className = _a.className, children = _a.children, _b = _a.asElement, Component = _b === void 0 ? 'a' : _b, rest = __rest(_a, ["className", "children", "asElement"]);
    return (React.createElement("li", { className: "nhsuk-breadcrumb__item" },
        React.createElement(Component, __assign({ className: classNames('nhsuk-breadcrumb__link', className) }, rest), children)));
};
var Back = function (_a) {
    var className = _a.className, _b = _a.asElement, Component = _b === void 0 ? 'a' : _b, rest = __rest(_a, ["className", "asElement"]);
    return (React.createElement("p", { className: classNames('nhsuk-breadcrumb__back', className) },
        React.createElement(Component, __assign({ className: "nhsuk-breadcrumb__backlink" }, rest))));
};
var Breadcrumb = function (_a) {
    var className = _a.className, children = _a.children, rest = __rest(_a, ["className", "children"]);
    // Split off any "Item" components
    var _b = React.Children.toArray(children).reduce(function (prev, child) {
        if (child && typeof child === 'object' && 'type' in child && child.type === Item) {
            prev.ItemChildren.push(child);
        }
        else {
            prev.OtherChildren.push(child);
        }
        return prev;
    }, {
        ItemChildren: [],
        OtherChildren: [],
    }), ItemChildren = _b.ItemChildren, OtherChildren = _b.OtherChildren;
    return (React.createElement("nav", __assign({ className: classNames('nhsuk-breadcrumb', className) }, rest),
        React.createElement(Container, null,
            React.createElement("ol", { className: "nhsuk-breadcrumb__list" }, ItemChildren),
            OtherChildren)));
};
Breadcrumb.Item = Item;
Breadcrumb.Back = Back;
Breadcrumb.defaultProps = {
    'aria-label': 'Breadcrumb',
};

var Button = function (_a) {
    var className = _a.className, type = _a.type, disabled = _a.disabled, secondary = _a.secondary, reverse = _a.reverse, rest = __rest(_a, ["className", "type", "disabled", "secondary", "reverse"]);
    return (
    // eslint-disable-next-line react/button-has-type
    React.createElement("button", __assign({ className: classNames('nhsuk-button', { 'nhsuk-button--disabled': disabled }, { 'nhsuk-button--secondary': secondary }, { 'nhsuk-button--reverse': reverse }, className), disabled: disabled, "aria-disabled": disabled ? 'true' : 'false', type: type }, rest)));
};
Button.defaultProps = {
    type: 'submit',
};
var ButtonLink = function (_a) {
    var className = _a.className, role = _a.role, draggable = _a.draggable, children = _a.children, disabled = _a.disabled, secondary = _a.secondary, reverse = _a.reverse, rest = __rest(_a, ["className", "role", "draggable", "children", "disabled", "secondary", "reverse"]);
    return (React.createElement("a", __assign({ className: classNames('nhsuk-button', { 'nhsuk-button--disabled': disabled }, { 'nhsuk-button--secondary': secondary }, { 'nhsuk-button--reverse': reverse }, className), role: role, "aria-disabled": disabled ? 'true' : 'false', draggable: draggable }, rest), children));
};
ButtonLink.defaultProps = {
    role: 'button',
    draggable: false,
};
var ButtonWrapper = function (_a) {
    var href = _a.href, as = _a.as, rest = __rest(_a, ["href", "as"]);
    if (as === 'a') {
        return React.createElement(ButtonLink, __assign({ href: href }, rest));
    }
    if (as === 'button') {
        return React.createElement(Button, __assign({}, rest));
    }
    if (href) {
        return React.createElement(ButtonLink, __assign({ href: href }, rest));
    }
    return React.createElement(Button, __assign({}, rest));
};

var HeadingLevel = function (_a) {
    var headingLevel = _a.headingLevel, rest = __rest(_a, ["headingLevel"]);
    switch (headingLevel) {
        case 'h1':
        case 'H1':
            return React.createElement("h1", __assign({}, rest));
        case 'h2':
        case 'H2':
            return React.createElement("h2", __assign({}, rest));
        case 'h3':
        case 'H3':
        default:
            return React.createElement("h3", __assign({}, rest));
        case 'h4':
        case 'H4':
            return React.createElement("h4", __assign({}, rest));
        case 'h5':
        case 'H5':
            return React.createElement("h5", __assign({}, rest));
        case 'h6':
        case 'H6':
            return React.createElement("h6", __assign({}, rest));
    }
};

var CareCardContext = createContext('non-urgent');
var genHiddenText = function (cardType) {
    switch (cardType) {
        case 'non-urgent':
            return 'Non-urgent advice: ';
        case 'urgent':
            return 'Urgent advice: ';
        case 'immediate':
            return 'Immediate action required: ';
        default:
            return '';
    }
};
var CareCardContent = function (_a) {
    var className = _a.className, rest = __rest(_a, ["className"]);
    return (React.createElement("div", __assign({ className: classNames('nhsuk-care-card__content', className) }, rest)));
};
var CareCardHeading = function (_a) {
    var className = _a.className, children = _a.children, visuallyHiddenText = _a.visuallyHiddenText, headingLevel = _a.headingLevel, role = _a.role, rest = __rest(_a, ["className", "children", "visuallyHiddenText", "headingLevel", "role"]);
    var cardType = useContext(CareCardContext);
    return (React.createElement("div", { className: "nhsuk-care-card__heading-container" },
        React.createElement(HeadingLevel, __assign({ className: classNames('nhsuk-care-card__heading', className), headingLevel: headingLevel }, rest),
            React.createElement("span", { role: role },
                visuallyHiddenText !== false ? (React.createElement("span", { className: "nhsuk-u-visually-hidden" }, visuallyHiddenText || genHiddenText(cardType))) : null,
                children)),
        React.createElement("span", { className: "nhsuk-care-card__arrow", "aria-hidden": "true" })));
};
CareCardHeading.defaultProps = {
    role: 'text',
};
var CareCard = function (_a) {
    var className = _a.className, type = _a.type, children = _a.children, rest = __rest(_a, ["className", "type", "children"]);
    return (React.createElement("div", __assign({ className: classNames('nhsuk-care-card', "nhsuk-care-card--" + type, className) }, rest),
        React.createElement(CareCardContext.Provider, { value: type }, children)));
};
CareCard.Content = CareCardContent;
CareCard.Heading = CareCardHeading;

var Hint = function (_a) {
    var className = _a.className, rest = __rest(_a, ["className"]);
    return (React.createElement("span", __assign({ className: classNames('nhsuk-hint', className) }, rest)));
};

var ErrorMessage = function (_a) {
    var className = _a.className, visuallyHiddenText = _a.visuallyHiddenText, children = _a.children, rest = __rest(_a, ["className", "visuallyHiddenText", "children"]);
    return (React.createElement("span", __assign({ className: classNames('nhsuk-error-message', className) }, rest),
        visuallyHiddenText !== false ? (React.createElement("span", { className: "nhsuk-u-visually-hidden" }, visuallyHiddenText)) : null,
        children));
};
ErrorMessage.defaultProps = {
    visuallyHiddenText: 'Error: ',
    role: 'alert',
};

var getRandomString = function (length) {
    if (length === void 0) { length = 5; }
    var randomNumber = Math.random() + 1;
    return randomNumber.toString(36).substring(2, length + 2);
};
var generateRandomName = function (prefix) {
    var randomString = getRandomString();
    return prefix ? prefix + "_" + randomString : randomString;
};
var generateRandomID = generateRandomName;

var BaseLabel = function (_a) {
    var _b;
    var className = _a.className, bold = _a.bold, size = _a.size, isPageHeading = _a.isPageHeading, rest = __rest(_a, ["className", "bold", "size", "isPageHeading"]);
    return (React.createElement("label", __assign({ className: classNames('nhsuk-label', { 'nhsuk-label--s': bold && !size }, { 'nhsuk-label--xl': isPageHeading && !size }, (_b = {}, _b["nhsuk-label--" + size] = size, _b), className) }, rest)));
};
var Label = function (_a) {
    var isPageHeading = _a.isPageHeading, rest = __rest(_a, ["isPageHeading"]);
    if (isPageHeading) {
        return (React.createElement("h1", { className: "nhsuk-label-wrapper" },
            React.createElement(BaseLabel, __assign({ isPageHeading: true }, rest))));
    }
    return React.createElement(BaseLabel, __assign({}, rest));
};

var FieldsetContext = createContext({
    isFieldset: false,
    passError: function () { },
    registerComponent: function () { },
});

var FormContext = createContext({
    disableErrorFromComponents: false,
});
var useFormContext = function () { return useContext(FormContext); };

var Form = function (_a) {
    var disableErrorFromComponents = _a.disableErrorFromComponents, rest = __rest(_a, ["disableErrorFromComponents"]);
    return (React.createElement(FormContext.Provider, { value: { disableErrorFromComponents: Boolean(disableErrorFromComponents) } },
        React.createElement("form", __assign({}, rest))));
};

var FormGroup = function (props) {
    var children = props.children, hint = props.hint, label = props.label, id = props.id, labelProps = props.labelProps, error = props.error, hintProps = props.hintProps, errorProps = props.errorProps, formGroupProps = props.formGroupProps, inputType = props.inputType, disableErrorLine = props.disableErrorLine, name = props.name, rest = __rest(props, ["children", "hint", "label", "id", "labelProps", "error", "hintProps", "errorProps", "formGroupProps", "inputType", "disableErrorLine", "name"]);
    var generatedID = useState(generateRandomID(inputType))[0];
    var _a = useContext(FieldsetContext), isFieldset = _a.isFieldset, registerComponent = _a.registerComponent, passError = _a.passError;
    var disableErrorFromComponents = useFormContext().disableErrorFromComponents;
    var elementID = id || generatedID;
    var labelID = elementID + "--label";
    var errorID = elementID + "--error-message";
    var hintID = elementID + "--hint";
    var childProps = __assign({ 'aria-describedby': hint ? hintID : undefined, 'aria-labelledby': label ? labelID : undefined, error: error, name: name || elementID, id: elementID }, rest);
    useEffect(function () {
        if (!isFieldset)
            return function () { };
        passError(elementID, disableErrorFromComponents ? false : Boolean(error));
        return function () { return passError(elementID, false); };
    }, [elementID, error, isFieldset]);
    useEffect(function () {
        registerComponent(elementID);
        return function () { return registerComponent(elementID, true); };
    }, []);
    var _b = formGroupProps || {}, formGroupClassName = _b.className, formGroupRestProps = __rest(_b, ["className"]);
    return (React.createElement("div", __assign({ className: classNames('nhsuk-form-group', {
            'nhsuk-form-group--error': !disableErrorFromComponents && !disableErrorLine && error,
        }, formGroupClassName) }, formGroupRestProps),
        label ? (React.createElement(Label, __assign({ id: labelID, htmlFor: elementID }, labelProps), label)) : null,
        hint ? (React.createElement(Hint, __assign({ id: hintID }, hintProps), hint)) : null,
        error && typeof error === 'string' ? (React.createElement(ErrorMessage, __assign({ id: errorID }, errorProps), error)) : null,
        children(childProps)));
};

var CheckboxContext = createContext({
    name: '',
    getBoxId: function () { return undefined; },
    setConditional: function () { },
    leaseReference: function () { return ''; },
    unleaseReference: function () { },
});

var Box = function (_a) {
    var id = _a.id, label = _a.label, labelProps = _a.labelProps, children = _a.children, hint = _a.hint, hintProps = _a.hintProps, conditional = _a.conditional, defaultChecked = _a.defaultChecked, checked = _a.checked, onChange = _a.onChange, inputRef = _a.inputRef, forceShowConditional = _a.forceShowConditional, conditionalWrapperProps = _a.conditionalWrapperProps, rest = __rest(_a, ["id", "label", "labelProps", "children", "hint", "hintProps", "conditional", "defaultChecked", "checked", "onChange", "inputRef", "forceShowConditional", "conditionalWrapperProps"]);
    var _b = useContext(CheckboxContext), getBoxId = _b.getBoxId, name = _b.name, setConditional = _b.setConditional, unleaseReference = _b.unleaseReference, leaseReference = _b.leaseReference;
    var boxReference = useState(leaseReference())[0];
    var _c = useState(!!(checked || defaultChecked)), showConditional = _c[0], setShowConditional = _c[1];
    var inputID = id || getBoxId(boxReference);
    var _d = labelProps || {}, labelClassName = _d.className, restLabelProps = __rest(_d, ["className"]);
    var _e = hintProps || {}, hintClassName = _e.className, restHintProps = __rest(_e, ["className"]);
    var _f = conditionalWrapperProps || {}, conditionalClassName = _f.className, restConditionalProps = __rest(_f, ["className"]);
    useEffect(function () { return function () { return unleaseReference(boxReference); }; }, []);
    useEffect(function () {
        if (checked !== undefined) {
            setShowConditional(checked);
        }
    }, [checked]);
    useEffect(function () {
        setConditional(boxReference, Boolean(conditional));
        return function () { return setConditional(boxReference, false); };
    }, [conditional]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "nhsuk-checkboxes__item" },
            React.createElement("input", __assign({ className: "nhsuk-checkboxes__input", onChange: function (e) {
                    if (checked === undefined)
                        setShowConditional(e.target.checked);
                    if (onChange)
                        onChange(e);
                }, name: name, id: inputID, checked: checked, defaultChecked: defaultChecked, ref: inputRef }, rest)),
            children ? (React.createElement(Label, __assign({ className: classNames('nhsuk-checkboxes__label', labelClassName), id: inputID + "--label", htmlFor: inputID }, restLabelProps), children)) : null,
            hint ? (React.createElement(Hint, __assign({ className: classNames('nhsuk-checkboxes__hint', hintClassName) }, restHintProps), hint)) : null),
        conditional && (showConditional || forceShowConditional) ? (React.createElement("div", __assign({ className: classNames('nhsuk-radios__conditional', conditionalClassName), id: inputID + "--conditional" }, restConditionalProps), conditional)) : null));
};
Box.defaultProps = {
    type: 'checkbox',
};

var Checkboxes = /** @class */ (function (_super) {
    __extends(Checkboxes, _super);
    function Checkboxes(props) {
        var rest = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            rest[_i - 1] = arguments[_i];
        }
        var _this = _super.apply(this, __spreadArrays([props], rest)) || this;
        _this.boxCount = 0;
        _this.boxReferences = [];
        _this.boxIds = {};
        _this.leaseReference = function () {
            var reference = generateRandomName();
            if (_this.boxReferences.includes(reference)) {
                return _this.leaseReference();
            }
            _this.boxReferences.push(reference);
            return reference;
        };
        _this.unleaseReference = function (reference) {
            _this.boxReferences = _this.boxReferences.filter(function (ref) { return ref !== reference; });
        };
        _this.setConditional = function (boxReference, hasConditional) {
            _this.setState(function (state) {
                var currentHasConditional = state.conditionalBoxes.includes(boxReference);
                if (currentHasConditional && hasConditional === false) {
                    return __assign(__assign({}, state), { conditionalBoxes: state.conditionalBoxes.filter(function (ref) { return ref !== boxReference; }) });
                }
                if (!currentHasConditional && hasConditional === true) {
                    return __assign(__assign({}, state), { conditionalBoxes: __spreadArrays(state.conditionalBoxes, [boxReference]) });
                }
                return state;
            });
        };
        _this.getBoxId = function (id, reference) {
            var idPrefix = _this.props.idPrefix;
            if (reference in _this.boxIds) {
                return _this.boxIds[reference];
            }
            _this.boxCount += 1;
            _this.boxIds[reference] = (idPrefix || id) + "-" + _this.boxCount;
            return _this.boxIds[reference];
        };
        _this.resetBoxIds = function () {
            _this.boxCount = 0;
            _this.boxIds = {};
        };
        _this.state = {
            conditionalBoxes: [],
        };
        return _this;
    }
    Checkboxes.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, rest = __rest(_a, ["children"]);
        return (React.createElement(FormGroup, __assign({ inputType: "checkboxes" }, rest), function (_a) {
            var className = _a.className, name = _a.name, id = _a.id, idPrefix = _a.idPrefix, restRenderProps = __rest(_a, ["className", "name", "id", "idPrefix"]);
            _this.resetBoxIds();
            var containsConditional = _this.state.conditionalBoxes.length > 0;
            var contextValue = {
                name: name,
                getBoxId: function (reference) { return _this.getBoxId(id, reference); },
                setConditional: _this.setConditional,
                leaseReference: _this.leaseReference,
                unleaseReference: _this.unleaseReference,
            };
            return (React.createElement("div", __assign({ className: classNames('nhsuk-checkboxes', { 'nhsuk-checkboxes--conditional': containsConditional }, className), id: id }, restRenderProps),
                React.createElement(CheckboxContext.Provider, { value: contextValue }, children)));
        }));
    };
    Checkboxes.Box = Box;
    return Checkboxes;
}(PureComponent));

var ContentsListItem = function (_a) {
    var className = _a.className, current = _a.current, rest = __rest(_a, ["className", "current"]);
    return (React.createElement("li", { className: classNames('nhsuk-contents-list__item', className) }, current ? (React.createElement("span", __assign({ className: "nhsuk-contents-list__current" }, rest))) : (React.createElement("a", __assign({ className: "nhsuk-contents-list__link" }, rest)))));
};
var ContentsList = function (_a) {
    var className = _a.className, children = _a.children, visuallyHiddenText = _a.visuallyHiddenText, rest = __rest(_a, ["className", "children", "visuallyHiddenText"]);
    return (React.createElement("nav", __assign({ className: classNames('nhsuk-contents-list', className) }, rest),
        visuallyHiddenText !== false ? (React.createElement("h2", { className: "nhsuk-u-visually-hidden" }, visuallyHiddenText)) : null,
        React.createElement("ol", { className: "nhsuk-contents-list__list" }, children)));
};
ContentsList.defaultProps = {
    role: 'navigation',
    visuallyHiddenText: 'Contents',
};
ContentsList.Item = ContentsListItem;

var DateInputContext = createContext({
    id: '',
    name: '',
    registerRef: function () { },
    handleChange: function () { },
    error: undefined,
});

var labels = {
    day: 'Day',
    month: 'Month',
    year: 'Year',
};
var IndividualDateInput = function (_a) {
    var label = _a.label, labelProps = _a.labelProps, inputType = _a.inputType, className = _a.className, id = _a.id, name = _a.name, onChange = _a.onChange, inputRef = _a.inputRef, error = _a.error, value = _a.value, defaultValue = _a.defaultValue, rest = __rest(_a, ["label", "labelProps", "inputType", "className", "id", "name", "onChange", "inputRef", "error", "value", "defaultValue"]);
    var _b = useContext(DateInputContext), ctxId = _b.id, ctxName = _b.name, ctxError = _b.error, ctxValue = _b.value, ctxDefaultValue = _b.defaultValue, ctxHandleChange = _b.handleChange, registerRef = _b.registerRef;
    var _c = labelProps || {}, labelClassName = _c.className, restLabelProps = __rest(_c, ["className"]);
    var inputID = id || ctxId + "-" + inputType;
    var inputName = name || ctxName + "-" + inputType;
    var inputValue = value !== undefined ? value : ctxValue === null || ctxValue === void 0 ? void 0 : ctxValue[inputType];
    var inputDefaultValue = defaultValue !== undefined ? defaultValue : ctxDefaultValue === null || ctxDefaultValue === void 0 ? void 0 : ctxDefaultValue[inputType];
    var handleChange = function (e) {
        e.persist();
        if (onChange)
            onChange(e);
        if (!e.isPropagationStopped()) {
            ctxHandleChange(inputType, e);
        }
    };
    var refCallback = function (ref) {
        registerRef(inputType, ref);
        if (inputRef)
            inputRef(ref);
    };
    return (React.createElement("div", { className: "nhsuk-date-input__item" },
        React.createElement("div", { className: "nhsuk-form-group" },
            React.createElement(Label, __assign({ className: classNames('nhsuk-date-input__label', labelClassName), id: inputID + "--label", htmlFor: inputID }, restLabelProps), label || labels[inputType]),
            React.createElement("input", __assign({ className: classNames('nhsuk-input nhsuk-date-input__input', { 'nhsuk-input--width-2': inputType === 'day' || inputType === 'month' }, { 'nhsuk-input--width-4': inputType === 'year' }, { 'nhsuk-input--error': error === undefined ? ctxError : error }, className), value: inputValue, defaultValue: inputDefaultValue, id: inputID, "aria-labelledby": restLabelProps.id || inputID + "--label", name: inputName, onChange: handleChange, ref: refCallback }, rest)))));
};
IndividualDateInput.defaultProps = {
    pattern: '[0-9]*',
    type: 'number',
};
var DayInput = function (props) { return (React.createElement(IndividualDateInput, __assign({ inputType: "day" }, props))); };
var MonthInput = function (props) { return (React.createElement(IndividualDateInput, __assign({ inputType: "month" }, props))); };
var YearInput = function (props) { return (React.createElement(IndividualDateInput, __assign({ inputType: "year" }, props))); };

var DateInput = /** @class */ (function (_super) {
    __extends(DateInput, _super);
    function DateInput(props) {
        var rest = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            rest[_i - 1] = arguments[_i];
        }
        var _a, _b, _c;
        var _this = _super.apply(this, __spreadArrays([props], rest)) || this;
        _this.handleSelectNext = function (inputType, value) {
            if (!_this.props.autoSelectNext)
                return;
            if (inputType === 'day' && value.length === 2 && _this.monthRef) {
                _this.monthRef.focus();
            }
            else if (inputType === 'month' && value.length === 2 && _this.yearRef) {
                _this.yearRef.focus();
            }
        };
        _this.handleChange = function (inputType, event) {
            _this.handleSelectNext(inputType, event.target.value);
            event.stopPropagation();
            _this.setState(function (state) {
                var _a;
                var newEventValue = __assign(__assign({}, state.values), (_a = {}, _a[inputType] = event.target.value, _a));
                if (_this.props.onChange) {
                    var newEvent = __assign(__assign({}, event), { target: __assign(__assign({}, event.target), { value: newEventValue }), currentTarget: __assign(__assign({}, event.currentTarget), { value: newEventValue }) });
                    _this.props.onChange(newEvent);
                }
                return { values: newEventValue };
            });
        };
        _this.registerRef = function (inputType, ref) {
            if (inputType === 'month')
                _this.monthRef = ref;
            if (inputType === 'year')
                _this.yearRef = ref;
        };
        _this.state = {
            values: {
                day: ((_a = props.value) === null || _a === void 0 ? void 0 : _a.day) || '',
                month: ((_b = props.value) === null || _b === void 0 ? void 0 : _b.month) || '',
                year: ((_c = props.value) === null || _c === void 0 ? void 0 : _c.year) || '',
            },
        };
        _this.monthRef = null;
        _this.yearRef = null;
        return _this;
    }
    DateInput.prototype.componentDidUpdate = function (prevProps) {
        var _this = this;
        if (this.props.value && prevProps.value !== this.props.value) {
            // This is the only way that we can update our internal state
            // when the value updates. We check if the value has changed first,
            // preventing an infinite loop.
            //
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState(function (state) {
                if (!_this.props.value)
                    return state;
                var newState = __assign({}, state);
                var _a = _this.props.value, day = _a.day, month = _a.month, year = _a.year;
                if (day && day !== state.values.day)
                    newState.values.day = day;
                if (month && month !== state.values.month)
                    newState.values.month = month;
                if (year && year !== state.values.year)
                    newState.values.year = year;
                return newState;
            });
        }
    };
    DateInput.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, onChange = _a.onChange, value = _a.value, defaultValue = _a.defaultValue, rest = __rest(_a, ["children", "onChange", "value", "defaultValue"]);
        return (React.createElement(FormGroup, __assign({ inputType: "dateinput" }, rest), function (_a) {
            var className = _a.className, name = _a.name, id = _a.id, error = _a.error, autoSelectNext = _a.autoSelectNext, restRenderProps = __rest(_a, ["className", "name", "id", "error", "autoSelectNext"]);
            var contextValue = {
                id: id,
                name: name,
                error: error,
                value: value,
                defaultValue: defaultValue,
                handleChange: _this.handleChange,
                registerRef: _this.registerRef,
            };
            return (React.createElement("div", __assign({ className: "nhsuk-date-input" }, restRenderProps, { id: id }),
                React.createElement(DateInputContext.Provider, { value: contextValue }, children || (React.createElement(React.Fragment, null,
                    React.createElement(DateInput.Day, null),
                    React.createElement(DateInput.Month, null),
                    React.createElement(DateInput.Year, null))))));
        }));
    };
    DateInput.Day = DayInput;
    DateInput.Month = MonthInput;
    DateInput.Year = YearInput;
    return DateInput;
}(PureComponent));

// TODO: Check if standard NHS.UK polyfill "details.polyfill.js" is required
var Details = function (_a) {
    var className = _a.className, expander = _a.expander, rest = __rest(_a, ["className", "expander"]);
    return (React.createElement("details", __assign({ className: classNames('nhsuk-details', { 'nhsuk-expander': expander }, className) }, rest)));
};
var DetailsSummary = function (_a) {
    var className = _a.className, children = _a.children, rest = __rest(_a, ["className", "children"]);
    return (React.createElement("summary", __assign({ className: classNames('nhsuk-details__summary', className) }, rest),
        React.createElement("span", { className: "nhsuk-details__summary-text" }, children)));
};
var DetailsText = function (_a) {
    var className = _a.className, rest = __rest(_a, ["className"]);
    return (React.createElement("div", __assign({ className: classNames('nhsuk-details__text', className) }, rest)));
};
var ExpanderGroup = function (_a) {
    var className = _a.className, rest = __rest(_a, ["className"]);
    return (React.createElement("div", __assign({ className: classNames('nhsuk-expander-group', className) }, rest)));
};
Details.Summary = DetailsSummary;
Details.Text = DetailsText;
Details.ExpanderGroup = ExpanderGroup;

var DoDontListContext = createContext('do');
var DoDontList = function (_a) {
    var className = _a.className, listType = _a.listType, children = _a.children, heading = _a.heading, headingLevel = _a.headingLevel, rest = __rest(_a, ["className", "listType", "children", "heading", "headingLevel"]);
    return (React.createElement("div", __assign({ className: classNames('nhsuk-do-dont-list', className) }, rest),
        React.createElement(HeadingLevel, { className: "nhsuk-do-dont-list__label", headingLevel: headingLevel }, heading || (listType === 'do' ? 'Do' : "Don't")),
        React.createElement("ul", { className: classNames('nhsuk-list', { 'nhsuk-list--tick': listType === 'do' }, { 'nhsuk-list--cross': listType === 'dont' }) },
            React.createElement(DoDontListContext.Provider, { value: listType }, children))));
};
var DoDontItem = function (_a) {
    var className = _a.className, children = _a.children, listItemType = _a.listItemType, rest = __rest(_a, ["className", "children", "listItemType"]);
    var listType = listItemType || useContext(DoDontListContext);
    return (React.createElement("li", __assign({}, rest),
        listType === 'do' ? React.createElement(Tick, null) : React.createElement(Cross, null),
        children));
};
DoDontList.Item = DoDontItem;

var ErrorSummaryTitle = function (_a) {
    var className = _a.className, rest = __rest(_a, ["className"]);
    return (React.createElement("h2", __assign({ className: classNames('nhsuk-error-summary__title', className) }, rest)));
};
var ErrorSummaryBody = function (_a) {
    var className = _a.className, rest = __rest(_a, ["className"]);
    return (React.createElement("div", __assign({ className: classNames('nhsuk-error-summary__body', className) }, rest)));
};
var ErrorSummaryList = function (_a) {
    var className = _a.className, rest = __rest(_a, ["className"]);
    return (React.createElement("ul", __assign({ className: classNames('nhsuk-list', 'nhsuk-error-summary__list', className) }, rest)));
};
var ErrorSummaryListItem = function (props) { return (React.createElement("li", null,
    React.createElement("a", __assign({}, props)))); };
var ErrorSummary = function (_a) {
    var className = _a.className, rest = __rest(_a, ["className"]);
    return (React.createElement("div", __assign({ className: classNames('nhsuk-error-summary', className) }, rest)));
};
ErrorSummary.Title = ErrorSummaryTitle;
ErrorSummary.Body = ErrorSummaryBody;
ErrorSummary.List = ErrorSummaryList;
ErrorSummary.Item = ErrorSummaryListItem;

var Legend = function (_a) {
    var _b;
    var className = _a.className, children = _a.children, isPageHeading = _a.isPageHeading, headingLevel = _a.headingLevel, size = _a.size, rest = __rest(_a, ["className", "children", "isPageHeading", "headingLevel", "size"]);
    return (React.createElement("legend", __assign({ className: classNames('nhsuk-fieldset__legend', {
            'nhsuk-fieldset__legend--xl': isPageHeading && !size,
        }, (_b = {}, _b["nhsuk-fieldset__legend--" + size] = size, _b), className) }, rest), isPageHeading ? (React.createElement(HeadingLevel, { className: "nhsuk-fieldset__heading", headingLevel: headingLevel }, children)) : (children)));
};
Legend.defaultProps = {
    headingLevel: 'h1',
};
var Fieldset = /** @class */ (function (_super) {
    __extends(Fieldset, _super);
    function Fieldset(props) {
        var rest = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            rest[_i - 1] = arguments[_i];
        }
        var _this = _super.apply(this, __spreadArrays([props], rest)) || this;
        _this.passError = function (componentId, error) {
            _this.setState(function (state) {
                var existingError = state.erroredComponents.includes(componentId);
                if (existingError && !error) {
                    return __assign(__assign({}, state), { erroredComponents: state.erroredComponents.filter(function (id) { return id !== componentId; }) });
                }
                if (!existingError && error) {
                    return __assign(__assign({}, state), { erroredComponents: __spreadArrays(state.erroredComponents, [componentId]) });
                }
                return state;
            });
        };
        _this.registerComponent = function (componentId, deregister) {
            if (deregister === void 0) { deregister = false; }
            _this.setState(function (state) {
                if (deregister) {
                    return __assign(__assign({}, state), { registeredComponents: state.registeredComponents.filter(function (id) { return id !== componentId; }) });
                }
                if (!state.registeredComponents.includes(componentId)) {
                    return __assign(__assign({}, state), { registeredComponents: __spreadArrays(state.registeredComponents, [componentId]) });
                }
                return state;
            });
        };
        _this.state = {
            registeredComponents: [],
            erroredComponents: [],
        };
        return _this;
    }
    Fieldset.prototype.render = function () {
        var _a = this.props, className = _a.className, disableErrorLine = _a.disableErrorLine, rest = __rest(_a, ["className", "disableErrorLine"]);
        var contextValue = {
            isFieldset: true,
            registerComponent: this.registerComponent,
            passError: this.passError,
        };
        var containsFormElements = this.state.registeredComponents.length > 0;
        var containsError = this.state.erroredComponents.length > 0;
        return (React.createElement(FieldsetContext.Provider, { value: contextValue }, containsFormElements ? (React.createElement("div", { className: classNames('nhsuk-form-group', {
                'nhsuk-form-group--error': disableErrorLine ? false : containsError,
            }) },
            React.createElement("fieldset", __assign({ className: classNames('nhsuk-fieldset', className) }, rest)))) : (React.createElement("fieldset", __assign({ className: classNames('nhsuk-fieldset', className) }, rest)))));
    };
    Fieldset.Legend = Legend;
    return Fieldset;
}(PureComponent));
Fieldset.Legend = Legend;

var FooterList = function (_a) {
    var className = _a.className, columns = _a.columns, rest = __rest(_a, ["className", "columns"]);
    return (React.createElement("ul", __assign({ className: classNames('nhsuk-footer__list', { 'nhsuk-footer__list--three-columns': columns }, className) }, rest)));
};
var FooterListItem = function (_a) {
    var className = _a.className, rest = __rest(_a, ["className"]);
    return (React.createElement("li", { className: "nhsuk-footer__list-item" },
        React.createElement("a", __assign({ className: classNames('nhsuk-footer__list-item-link', className) }, rest))));
};
var FooterCopyright = function (_a) {
    var className = _a.className, rest = __rest(_a, ["className"]);
    return (React.createElement("p", __assign({ className: classNames('nhsuk-footer__copyright', className) }, rest)));
};
var Footer = function (_a) {
    var className = _a.className, children = _a.children, visuallyHiddenText = _a.visuallyHiddenText, rest = __rest(_a, ["className", "children", "visuallyHiddenText"]);
    return (React.createElement("footer", __assign({}, rest),
        React.createElement("div", { className: classNames('nhsuk-footer', className) },
            React.createElement(Container, null,
                visuallyHiddenText ? (React.createElement("h2", { className: "nhsuk-u-visually-hidden" }, visuallyHiddenText)) : null,
                children))));
};
Footer.defaultProps = {
    visuallyHiddenText: 'Support links',
};
Footer.List = FooterList;
Footer.ListItem = FooterListItem;
Footer.Copyright = FooterCopyright;

var HeaderContext = createContext({
    orgName: undefined,
    serviceName: undefined,
    orgSplit: undefined,
    orgDescriptor: undefined,
    setSearch: function () { },
    setMenuToggle: function () { },
    hasSearch: false,
    hasMenuToggle: false,
    toggleMenu: function () { },
    toggleSearch: function () { },
    menuOpen: false,
    searchOpen: false,
});

var SVGImageWithSrc = function (props) { return React.createElement("image", __assign({}, props)); };
var NHSLogo = function (_a) {
    var className = _a.className, alt = _a.alt, _b = _a.asElement, Component = _b === void 0 ? 'a' : _b, rest = __rest(_a, ["className", "alt", "asElement"]);
    var _c = useContext(HeaderContext), serviceName = _c.serviceName, hasMenuToggle = _c.hasMenuToggle, hasSearch = _c.hasSearch;
    return (React.createElement("div", { className: classNames('nhsuk-header__logo', {
            'nhsuk-header__logo--only': !hasMenuToggle && !hasSearch,
        }) },
        React.createElement(Component, __assign({ className: classNames('nhsuk-header__link', { 'nhsuk-header__link--service': serviceName }, className) }, rest),
            React.createElement("svg", { className: "nhsuk-logo", xmlns: "http://www.w3.org/2000/svg", role: "img", focusable: "false", viewBox: "0 0 40 16", "aria-labelledby": "nhsuk-logo_title" },
                React.createElement("title", { id: "nhsuk-logo_title" }, alt),
                React.createElement("path", { className: "nhsuk-logo__background", d: "M0 0h40v16H0z" }),
                React.createElement("path", { className: "nhsuk-logo__text", d: "M3.9 1.5h4.4l2.6 9h.1l1.8-9h3.3l-2.8 13H9l-2.7-9h-.1l-1.8 9H1.1M17.3 1.5h3.6l-1 4.9h4L25 1.5h3.5l-2.7 13h-3.5l1.1-5.6h-4.1l-1.2 5.6h-3.4M37.7 4.4c-.7-.3-1.6-.6-2.9-.6-1.4 0-2.5.2-2.5 1.3 0 1.8 5.1 1.2 5.1 5.1 0 3.6-3.3 4.5-6.4 4.5-1.3 0-2.9-.3-4-.7l.8-2.7c.7.4 2.1.7 3.2.7s2.8-.2 2.8-1.5c0-2.1-5.1-1.3-5.1-5 0-3.4 2.9-4.4 5.8-4.4 1.6 0 3.1.2 4 .6" }),
                React.createElement(SVGImageWithSrc, { src: "https://assets.nhs.uk/images/nhs-logo.png", xlinkHref: "" })),
            serviceName ? React.createElement("span", { className: "nhsuk-header__service-name" }, serviceName) : null)));
};
NHSLogo.defaultProps = {
    'aria-label': 'NHS homepage',
    alt: 'NHS Logo',
};

var OrganisationalLogo = function (_a) {
    var logoUrl = _a.logoUrl, alt = _a.alt, _b = _a.asElement, Component = _b === void 0 ? 'a' : _b, rest = __rest(_a, ["logoUrl", "alt", "asElement"]);
    var _c = useContext(HeaderContext), orgName = _c.orgName, orgSplit = _c.orgSplit, orgDescriptor = _c.orgDescriptor;
    return (React.createElement("div", { className: "nhsuk-header__logo" },
        React.createElement(Component, __assign({ className: "nhsuk-header__link" }, rest), logoUrl ? (React.createElement("img", { className: "nhsuk-org-logo", src: logoUrl, alt: alt })) : (React.createElement(React.Fragment, null,
            React.createElement("svg", { className: "nhsuk-logo", xmlns: "http://www.w3.org/2000/svg", role: "img", focusable: "false", viewBox: "0 0 40 16", "aria-labelledby": "nhsuk-logo_title" },
                React.createElement("title", { id: "nhsuk-logo_title" }, alt),
                React.createElement("path", { className: "nhsuk-logo__background", d: "M0 0h40v16H0z" }),
                React.createElement("path", { className: "nhsuk-logo__text", d: "M3.9 1.5h4.4l2.6 9h.1l1.8-9h3.3l-2.8 13H9l-2.7-9h-.1l-1.8 9H1.1M17.3 1.5h3.6l-1 4.9h4L25 1.5h3.5l-2.7 13h-3.5l1.1-5.6h-4.1l-1.2 5.6h-3.4M37.7 4.4c-.7-.3-1.6-.6-2.9-.6-1.4 0-2.5.2-2.5 1.3 0 1.8 5.1 1.2 5.1 5.1 0 3.6-3.3 4.5-6.4 4.5-1.3 0-2.9-.3-4-.7l.8-2.7c.7.4 2.1.7 3.2.7s2.8-.2 2.8-1.5c0-2.1-5.1-1.3-5.1-5 0-3.4 2.9-4.4 5.8-4.4 1.6 0 3.1.2 4 .6" }),
                React.createElement("img", { src: "https://assets.nhs.uk/images/nhs-logo.png" })),
            React.createElement("span", { className: "nhsuk-organisation-name" },
                orgName,
                orgSplit ? (React.createElement(React.Fragment, null,
                    ' ',
                    React.createElement("span", { className: "nhsuk-organisation-name-split" }, orgSplit))) : null),
            orgDescriptor ? (React.createElement("span", { className: "nhsuk-organisation-descriptor" }, orgDescriptor)) : null)))));
};

var Search$1 = function (_a) {
    var action = _a.action, method = _a.method, id = _a.id, visuallyHiddenText = _a.visuallyHiddenText, rest = __rest(_a, ["action", "method", "id", "visuallyHiddenText"]);
    var _b = useContext(HeaderContext), setSearch = _b.setSearch, toggleSearch = _b.toggleSearch, searchOpen = _b.searchOpen;
    useEffect(function () {
        setSearch(true);
        return function () { return setSearch(false); };
    }, []);
    return (React.createElement("div", { className: "nhsuk-header__search" },
        React.createElement("button", { className: classNames('nhsuk-header__search-toggle', { 'is-active': searchOpen }), "aria-label": "Open search", "aria-expanded": searchOpen ? 'true' : 'false', onClick: toggleSearch },
            React.createElement(Search, null),
            React.createElement("span", { className: "nhsuk-u-visually-hidden" }, "Search")),
        React.createElement("div", { className: classNames('nhsuk-header__search-wrap', { 'js-show': searchOpen }) },
            React.createElement("form", { className: "nhsuk-header__search-form", action: action, method: method, role: "search" },
                React.createElement("label", { className: "nhsuk-u-visually-hidden", htmlFor: id }, visuallyHiddenText),
                React.createElement("input", __assign({ className: "nhsuk-search__input", id: id }, rest)),
                React.createElement("button", { className: "nhsuk-search__submit", type: "submit" },
                    React.createElement(Search, null),
                    React.createElement("span", { className: "nhsuk-u-visually-hidden" }, "Search")),
                React.createElement("button", { className: "nhsuk-search__close" },
                    React.createElement(Close, null),
                    React.createElement("span", { className: "nhsuk-u-visually-hidden" }, "Close search"))))));
};
Search$1.defaultProps = {
    method: 'get',
    role: 'search',
    id: 'search-field',
    visuallyHiddenText: 'Search the NHS website',
    type: 'search',
    autoComplete: 'off',
    placeholder: 'Search',
};

var Nav = function (_a) {
    var className = _a.className, children = _a.children, onClick = _a.onClick, open = _a.open, rest = __rest(_a, ["className", "children", "onClick", "open"]);
    var _b = useContext(HeaderContext), menuOpen = _b.menuOpen, toggleMenu = _b.toggleMenu;
    return (React.createElement("nav", __assign({ className: classNames('nhsuk-header__navigation', { 'js-show': open !== undefined ? open : menuOpen }, className) }, rest),
        React.createElement(Container, null,
            React.createElement("p", { className: "nhsuk-header__navigation-title" },
                React.createElement("span", null, "Menu"),
                React.createElement("button", { className: "nhsuk-header__navigation-close", type: "button", onClick: toggleMenu },
                    React.createElement(Close, null),
                    React.createElement("span", { className: "nhsuk-u-visually-hidden" }, "Close menu"))),
            React.createElement("ul", { className: "nhsuk-header__navigation-list" }, children))));
};

var NavItem = function (_a) {
    var mobileOnly = _a.mobileOnly, className = _a.className, children = _a.children, _b = _a.asElement, Component = _b === void 0 ? 'a' : _b, rest = __rest(_a, ["mobileOnly", "className", "children", "asElement"]);
    return (React.createElement("li", { className: classNames('nhsuk-header__navigation-item', { 'nhsuk-header__navigation-item--for-mobile': mobileOnly }, className) },
        React.createElement(Component, __assign({ className: "nhsuk-header__navigation-link" }, rest),
            children,
            React.createElement(ChevronRight, null))));
};

var NavItemList = function (_a) {
    var children = _a.children, className = _a.className, rest = __rest(_a, ["children", "className"]);
    return (React.createElement("ul", __assign({ className: classNames('nhsuk-header__navigation-list', className) }, rest), children));
};

var NavMenuClose = function (_a) {
    var className = _a.className, rest = __rest(_a, ["className"]);
    var toggleMenu = useContext(HeaderContext).toggleMenu;
    return (React.createElement("button", __assign({ className: classNames('nhsuk-header__navigation-close', className) }, rest, { type: "button", onClick: toggleMenu }),
        React.createElement(Close, null),
        React.createElement("span", { className: "nhsuk-u-visually-hidden" }, "Close menu")));
};

var Content = function (_a) {
    var className = _a.className, rest = __rest(_a, ["className"]);
    var searchOpen = useContext(HeaderContext).searchOpen;
    return (React.createElement("div", __assign({ className: classNames('nhsuk-header__content', { 'js-show': searchOpen }, className) }, rest)));
};

var MenuToggle = function (_a) {
    var onClick = _a.onClick, rest = __rest(_a, ["onClick"]);
    var _b = useContext(HeaderContext), setMenuToggle = _b.setMenuToggle, toggleMenu = _b.toggleMenu, menuOpen = _b.menuOpen;
    var onToggleClick = function (e) {
        toggleMenu();
        if (onClick) {
            onClick(e);
        }
    };
    useEffect(function () {
        setMenuToggle(true);
        return function () { return setMenuToggle(false); };
    }, []);
    return (React.createElement("div", { className: "nhsuk-header__menu" },
        React.createElement("button", __assign({ className: classNames('nhsuk-header__menu-toggle', { 'is-active': menuOpen }), "aria-label": "Open menu", "aria-expanded": menuOpen ? 'true' : 'false', onClick: onToggleClick }, rest), "Menu")));
};

var TransactionalServiceName = function (_a) {
    var className = _a.className, long = _a.long, rest = __rest(_a, ["className", "long"]);
    return (React.createElement("div", { className: classNames('nhsuk-header__transactional-service-name', { 'nhsuk-header__transactional-service-name--long': long }, className) },
        React.createElement("a", __assign({ className: "nhsuk-header__transactional-service-name--link" }, rest))));
};

var NavTitle = function (_a) {
    var children = _a.children, className = _a.className, rest = __rest(_a, ["children", "className"]);
    return (React.createElement("p", __assign({ className: classNames('nhsuk-header__navigation-title', className) }, rest), children));
};

var NavContainer = function (_a) {
    var className = _a.className, children = _a.children, open = _a.open, rest = __rest(_a, ["className", "children", "open"]);
    var menuOpen = useContext(HeaderContext).menuOpen;
    return (React.createElement("nav", __assign({ className: classNames('nhsuk-header__navigation', { 'js-show': open !== undefined ? open : menuOpen }, className) }, rest),
        React.createElement(Container, null, children)));
};

var BaseHeaderLogo = function (props) {
    var orgName = useContext(HeaderContext).orgName;
    if (orgName) {
        return React.createElement(OrganisationalLogo, __assign({}, props));
    }
    return React.createElement(NHSLogo, __assign({}, props));
};
var HeaderContainer = function (_a) {
    var className = _a.className, rest = __rest(_a, ["className"]);
    return (React.createElement(Container, __assign({ className: classNames('nhsuk-header__container', className) }, rest)));
};
var Header = /** @class */ (function (_super) {
    __extends(Header, _super);
    function Header(props) {
        var rest = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            rest[_i - 1] = arguments[_i];
        }
        var _this = _super.apply(this, __spreadArrays([props], rest)) || this;
        _this.setMenuToggle = function (toggle) {
            _this.setState({ hasMenuToggle: toggle });
        };
        _this.setSearch = function (toggle) {
            _this.setState({ hasSearch: toggle });
        };
        _this.toggleMenu = function () {
            _this.setState(function (state) { return ({ menuOpen: !state.menuOpen }); });
        };
        _this.toggleSearch = function () {
            _this.setState(function (state) { return ({ searchOpen: !state.searchOpen }); });
        };
        _this.state = {
            hasMenuToggle: false,
            hasSearch: false,
            menuOpen: false,
            searchOpen: false,
        };
        return _this;
    }
    Header.prototype.render = function () {
        var _a = this.props, className = _a.className, children = _a.children, transactional = _a.transactional, orgName = _a.orgName, orgSplit = _a.orgSplit, orgDescriptor = _a.orgDescriptor, serviceName = _a.serviceName, white = _a.white, rest = __rest(_a, ["className", "children", "transactional", "orgName", "orgSplit", "orgDescriptor", "serviceName", "white"]);
        var _b = this.state, hasSearch = _b.hasSearch, hasMenuToggle = _b.hasMenuToggle, menuOpen = _b.menuOpen, searchOpen = _b.searchOpen;
        var contextValue = {
            orgName: orgName,
            orgSplit: orgSplit,
            orgDescriptor: orgDescriptor,
            serviceName: serviceName,
            hasSearch: hasSearch,
            hasMenuToggle: hasMenuToggle,
            setMenuToggle: this.setMenuToggle,
            setSearch: this.setSearch,
            toggleMenu: this.toggleMenu,
            toggleSearch: this.toggleSearch,
            menuOpen: menuOpen,
            searchOpen: searchOpen,
        };
        return (React.createElement("header", __assign({ className: classNames('nhsuk-header', { 'nhsuk-header--transactional': transactional }, { 'nhsuk-header--organisation': orgName }, { 'nhsuk-header--white': white }, className) }, rest),
            React.createElement(HeaderContext.Provider, { value: contextValue }, children)));
    };
    Header.Logo = BaseHeaderLogo;
    Header.Search = Search$1;
    Header.Nav = Nav;
    Header.NavTitle = NavTitle;
    Header.NavContainer = NavContainer;
    Header.NavItemList = NavItemList;
    Header.NavItem = NavItem;
    Header.NavMenuClose = NavMenuClose;
    Header.Container = HeaderContainer;
    Header.Content = Content;
    Header.MenuToggle = MenuToggle;
    Header.ServiceName = TransactionalServiceName;
    Header.defaultProps = {
        role: 'banner',
    };
    return Header;
}(PureComponent));

var HeroContent = function (_a) {
    var children = _a.children, hasImage = _a.hasImage;
    if (!children) {
        return null;
    }
    return (React.createElement(Container, { className: classNames({ 'nhsuk-hero--border': hasImage }) },
        React.createElement(Row, null,
            React.createElement(Col, { width: "two-thirds" }, hasImage ? (React.createElement("div", { className: "nhsuk-hero-content" },
                children,
                React.createElement("span", { className: "nhsuk-hero__arrow", "aria-hidden": "true" }))) : (React.createElement("div", { className: "nhsuk-hero__wrapper" }, children))))));
};
var HeroHeading = function (_a) {
    var className = _a.className, rest = __rest(_a, ["className"]);
    return (React.createElement("h1", __assign({ className: classNames('nhsuk-u-margin-bottom-3', className) }, rest)));
};
var HeroText = function (_a) {
    var className = _a.className, rest = __rest(_a, ["className"]);
    return (React.createElement("p", __assign({ className: classNames('nhsuk-body-l nhsuk-u-margin-bottom-0', className) }, rest)));
};
var Hero = function (_a) {
    var className = _a.className, children = _a.children, imageSrc = _a.imageSrc, rest = __rest(_a, ["className", "children", "imageSrc"]);
    return (React.createElement("section", __assign({ className: classNames('nhsuk-hero', { 'nhsuk-hero--image': imageSrc }, { 'nhsuk-hero--image-description': imageSrc && children }, className), style: imageSrc ? { backgroundImage: "url('" + imageSrc + "')" } : undefined }, rest), imageSrc ? (React.createElement("div", { className: "nhsuk-hero__overlay" },
        React.createElement(HeroContent, { hasImage: Boolean(imageSrc) }, children))) : (React.createElement(HeroContent, { hasImage: Boolean(imageSrc) }, children))));
};
Hero.Heading = HeroHeading;
Hero.Text = HeroText;

var Images = function (_a) {
    var className = _a.className, src = _a.src, caption = _a.caption, rest = __rest(_a, ["className", "src", "caption"]);
    return (React.createElement("figure", { className: "nhsuk-image" },
        React.createElement("img", __assign({ className: classNames('nhsuk-image__img', className) }, rest)),
        caption ? React.createElement("figcaption", { className: "nhsuk-image__caption" }, caption) : null));
};

var Input = function (props) { return (React.createElement(FormGroup, __assign({}, props, { inputType: "input" }), function (_a) {
    var _b;
    var width = _a.width, className = _a.className, error = _a.error, inputRef = _a.inputRef, rest = __rest(_a, ["width", "className", "error", "inputRef"]);
    return (React.createElement("input", __assign({ className: classNames('nhsuk-input', (_b = {}, _b["nhsuk-input--width-" + width] = width, _b), { 'nhsuk-input--error': error }, className), ref: inputRef }, rest)));
})); };
Input.defaultProps = {
    type: 'text',
};

var InsetText = function (_a) {
    var className = _a.className, children = _a.children, visuallyHiddenText = _a.visuallyHiddenText, rest = __rest(_a, ["className", "children", "visuallyHiddenText"]);
    return (React.createElement("div", __assign({ className: classNames('nhsuk-inset-text', className) }, rest),
        visuallyHiddenText ? (React.createElement("span", { className: "nhsuk-u-visually-hidden" }, visuallyHiddenText)) : null,
        children));
};
InsetText.defaultProps = {
    visuallyHiddenText: 'Information: ',
};

var Panel = function (_a) {
    var className = _a.className, children = _a.children, noResults = _a.noResults, label = _a.label, labelProps = _a.labelProps, backToTop = _a.backToTop, backToTopLink = _a.backToTopLink, backToTopButtonText = _a.backToTopButtonText, rest = __rest(_a, ["className", "children", "noResults", "label", "labelProps", "backToTop", "backToTopLink", "backToTopButtonText"]);
    return (React.createElement("li", null,
        React.createElement("div", __assign({ className: classNames('nhsuk-list-panel', className) }, rest),
            label ? (React.createElement("h2", __assign({ className: "nhsuk-list-panel__label" }, labelProps), label)) : null,
            noResults ? (React.createElement("div", { className: classNames('nhsuk-list-panel__box', {
                    'nhsuk-list-panel__box--with-label': label,
                }) },
                React.createElement("p", { className: "nhsuk-list-panel--results-items__no-results" }, children))) : (React.createElement("ul", { className: classNames('nhsuk-list-panel__list', {
                    'nhsuk-list-panel__list--with-label': label,
                }) }, children)),
            backToTop ? (React.createElement("div", { className: "nhsuk-back-to-top" },
                React.createElement("a", { className: "nhsuk-back-to-top__link", href: backToTopLink },
                    React.createElement("svg", { className: "nhsuk-icon nhsuk-icon__arrow-right", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", "aria-hidden": "true" },
                        React.createElement("path", { d: "M19.6 11.66l-2.73-3A.51.51 0 0 0 16 9v2H5a1 1 0 0 0 0 2h11v2a.5.5 0 0 0 .32.46.39.39 0 0 0 .18 0 .52.52 0 0 0 .37-.16l2.73-3a.5.5 0 0 0 0-.64z" })),
                    backToTopButtonText || 'Back to top'))) : null)));
};
var PanelItem = function (_a) {
    var className = _a.className, rest = __rest(_a, ["className"]);
    return (React.createElement("li", __assign({ className: classNames('nhsuk-list-panel__item', className) }, rest)));
};
var PanelLinkItem = function (_a) {
    var className = _a.className, _b = _a.asElement, Component = _b === void 0 ? 'a' : _b, rest = __rest(_a, ["className", "asElement"]);
    return (React.createElement(PanelItem, null,
        React.createElement(Component, __assign({ className: classNames('nhsuk-list-panel__link', className) }, rest))));
};
var ListPanel = function (_a) {
    var className = _a.className, children = _a.children, rest = __rest(_a, ["className", "children"]);
    return (React.createElement("ol", __assign({ className: classNames('nhsuk-list', className) }, rest), children));
};
ListPanel.LinkItem = PanelLinkItem;
ListPanel.Item = PanelItem;
ListPanel.Panel = Panel;

var alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
var processLetters = function (children, fullAlphabet, removedLetters, disabledLetters, letters) {
    var letterMap = function (letter) {
        if (removedLetters && removedLetters.includes(letter)) {
            return null;
        }
        if (disabledLetters && disabledLetters.includes(letter)) {
            return React.createElement(DisabledItem, { key: letter }, letter);
        }
        return (React.createElement(LinkItem, { key: letter, href: "#" + letter }, letter));
    };
    if (children) {
        return children;
    }
    if (fullAlphabet) {
        return alphabet.split('').map(letterMap);
    }
    if (letters) {
        return letters.map(letterMap);
    }
    return null;
};
var NavAZ = function (_a) {
    var className = _a.className, children = _a.children, fullAlphabet = _a.fullAlphabet, removedLetters = _a.removedLetters, disabledLetters = _a.disabledLetters, letters = _a.letters, rest = __rest(_a, ["className", "children", "fullAlphabet", "removedLetters", "disabledLetters", "letters"]);
    return (React.createElement("nav", __assign({ className: classNames('nhsuk-nav-a-z', className) }, rest),
        React.createElement("ol", { className: "nhsuk-nav-a-z__list" }, processLetters(children, fullAlphabet, removedLetters, disabledLetters, letters))));
};
var LinkItem = function (_a) {
    var className = _a.className, _b = _a.asElement, Component = _b === void 0 ? 'a' : _b, rest = __rest(_a, ["className", "asElement"]);
    return (React.createElement("li", { className: "nhsuk-nav-a-z__item" },
        React.createElement(Component, __assign({ className: classNames('nhsuk-nav-a-z__link', className) }, rest))));
};
var DisabledItem = function (_a) {
    var className = _a.className, rest = __rest(_a, ["className"]);
    return (React.createElement("li", { className: "nhsuk-nav-a-z__item" },
        React.createElement("span", __assign({ className: classNames('nhsuk-nav-a-z__link--disabled', className) }, rest))));
};
NavAZ.LinkItem = LinkItem;
NavAZ.DisabledItem = DisabledItem;

var PaginationLink = function (_a) {
    var className = _a.className, children = _a.children, previous = _a.previous, next = _a.next, rest = __rest(_a, ["className", "children", "previous", "next"]);
    return (React.createElement("li", { className: classNames({ 'nhsuk-pagination-item--previous': previous }, { 'nhsuk-pagination-item--next': next }) },
        React.createElement("a", __assign({ className: classNames('nhsuk-pagination__link', { 'nhsuk-pagination__link--prev': previous }, { 'nhsuk-pagination__link--next': next }, className) }, rest),
            React.createElement("span", { className: "nhsuk-pagination__title" },
                previous ? 'Previous' : null,
                next ? 'Next' : null),
            React.createElement("span", { className: "nhsuk-u-visually-hidden" }, ":"),
            React.createElement("span", { className: "nhsuk-pagination__page" }, children),
            previous ? React.createElement(ArrowLeft, null) : null,
            next ? React.createElement(ArrowRight, null) : null)));
};
var Pagination = function (_a) {
    var className = _a.className, children = _a.children, rest = __rest(_a, ["className", "children"]);
    return (React.createElement("nav", __assign({ className: classNames('nhsuk-pagination', className) }, rest),
        React.createElement("ul", { className: "nhsuk-list nhsuk-pagination__list" }, children)));
};
Pagination.defaultProps = {
    role: 'navigation',
    'aria-label': 'Pagination',
};
Pagination.Link = PaginationLink;

var PanelContext = createContext(null);

var BasePanel = function (_a) {
    var label = _a.label, grey = _a.grey, className = _a.className, labelProps = _a.labelProps, children = _a.children, rest = __rest(_a, ["label", "grey", "className", "labelProps", "children"]);
    return (React.createElement("div", __assign({ className: classNames({ 'nhsuk-panel': !label }, { 'nhsuk-panel--grey': grey }, { 'nhsuk-panel-with-label': label }, className) }, rest),
        label ? (React.createElement("h3", __assign({ className: "nhsuk-panel-with-label__label" }, labelProps), label)) : null,
        children));
};
var Panel$1 = function (props) {
    var PanelGroupContext = React.useContext(PanelContext);
    var panelWidth;
    if (PanelGroupContext !== null) {
        var panelCount = PanelGroupContext.panelCount;
        switch (panelCount) {
            case 2:
                panelWidth = 'one-half';
                break;
            case 3:
                panelWidth = 'one-third';
                break;
            case 4:
                panelWidth = 'one-quarter';
                break;
            default:
                panelWidth = 'full';
                break;
        }
        return (React.createElement(Col, { width: panelWidth, className: "nhsuk-panel-group__item" },
            React.createElement(BasePanel, __assign({}, props))));
    }
    return React.createElement(BasePanel, __assign({}, props));
};
var PanelGroup = function (_a) {
    var className = _a.className, children = _a.children, rest = __rest(_a, ["className", "children"]);
    var panelCount = 0;
    React.Children.forEach(children, function (child) {
        if (child && isValidElement(child) && child.type === Panel$1) {
            panelCount += 1;
        }
    });
    return (React.createElement(Row, __assign({ className: classNames('nhsuk-panel-group', className) }, rest),
        React.createElement(PanelContext.Provider, { value: { panelCount: panelCount } }, children)));
};
Panel$1.Group = PanelGroup;

var PromoContext = createContext({ isGroup: false, promoCount: 0 });

var BasePromo = function (_a) {
    var className = _a.className, children = _a.children, imageSrc = _a.imageSrc, imageProps = _a.imageProps, small = _a.small, _b = _a.asElement, Component = _b === void 0 ? 'a' : _b, rest = __rest(_a, ["className", "children", "imageSrc", "imageProps", "small", "asElement"]);
    var _c = imageProps || {}, imageClassName = _c.className, restImageProps = __rest(_c, ["className"]);
    return (React.createElement("div", { className: classNames('nhsuk-promo', { 'nhsuk-promo--small': small }, className) },
        React.createElement(Component, __assign({ className: "nhsuk-promo__link-wrapper" }, rest),
            imageSrc ? (React.createElement("img", __assign({ className: classNames('nhsuk-promo__img', imageClassName), src: imageSrc }, restImageProps))) : null,
            React.createElement("div", { className: "nhsuk-promo__content" }, children))));
};
BasePromo.defaultProps = {
    imageProps: {},
};
var PromoHeading = function (_a) {
    var className = _a.className, rest = __rest(_a, ["className"]);
    return (React.createElement("h3", __assign({ className: classNames('nhsuk-promo__heading', className) }, rest)));
};
var PromoDescription = function (_a) {
    var className = _a.className, rest = __rest(_a, ["className"]);
    return (React.createElement("p", __assign({ className: classNames('nhsuk-promo__description', className) }, rest)));
};
var PromoGroup = function (_a) {
    var className = _a.className, children = _a.children, rest = __rest(_a, ["className", "children"]);
    var promoCount = 0;
    React.Children.forEach(children, function (child) {
        if (child && isValidElement(child) && child.type === Promo) {
            promoCount += 1;
        }
    });
    return (React.createElement(Row, __assign({ className: classNames('nhsuk-promo-group', className) }, rest),
        React.createElement(PromoContext.Provider, { value: { promoCount: promoCount, isGroup: true } }, children)));
};
var Promo = function (props) {
    var _a = useContext(PromoContext), isGroup = _a.isGroup, promoCount = _a.promoCount;
    var promoWidth;
    if (isGroup) {
        switch (promoCount) {
            case 2:
                promoWidth = 'one-half';
                break;
            case 3:
                promoWidth = 'one-third';
                break;
            case 4:
                promoWidth = 'one-quarter';
                break;
            default:
                promoWidth = 'full';
                break;
        }
        return (React.createElement(Col, { className: "nhsuk-promo-group__item", width: promoWidth },
            React.createElement(BasePromo, __assign({}, props))));
    }
    return React.createElement(BasePromo, __assign({}, props));
};
Promo.Group = PromoGroup;
Promo.Description = PromoDescription;
Promo.Heading = PromoHeading;

var RadiosContext = createContext({
    name: '',
    selectedRadio: '',
    getRadioId: function () { return ''; },
    setConditional: function () { },
    setSelected: function () { },
    leaseReference: function () { return ''; },
    unleaseReference: function () { },
});

var Divider = function (_a) {
    var className = _a.className, rest = __rest(_a, ["className"]);
    return (React.createElement("div", __assign({ className: classNames('nhsuk-radios__divider', className) }, rest)));
};

var Radio = function (_a) {
    var className = _a.className, children = _a.children, id = _a.id, hint = _a.hint, hintProps = _a.hintProps, labelProps = _a.labelProps, conditional = _a.conditional, forceShowConditional = _a.forceShowConditional, conditionalWrapperProps = _a.conditionalWrapperProps, checked = _a.checked, defaultChecked = _a.defaultChecked, onChange = _a.onChange, inputRef = _a.inputRef, rest = __rest(_a, ["className", "children", "id", "hint", "hintProps", "labelProps", "conditional", "forceShowConditional", "conditionalWrapperProps", "checked", "defaultChecked", "onChange", "inputRef"]);
    var _b = useContext(RadiosContext), name = _b.name, getRadioId = _b.getRadioId, setConditional = _b.setConditional, setSelected = _b.setSelected, selectedRadio = _b.selectedRadio, leaseReference = _b.leaseReference, unleaseReference = _b.unleaseReference;
    var radioReference = useState(leaseReference())[0];
    var inputID = id || getRadioId(radioReference);
    var shouldShowConditional = selectedRadio === radioReference && checked !== false;
    useEffect(function () { return function () { return unleaseReference(radioReference); }; });
    useEffect(function () {
        if (defaultChecked)
            setSelected(radioReference);
    }, []);
    useEffect(function () {
        if (checked)
            setSelected(radioReference);
    }, [checked]);
    useEffect(function () {
        setConditional(radioReference, Boolean(conditional));
        return function () { return setConditional(radioReference, false); };
    }, [conditional]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "nhsuk-radios__item" },
            React.createElement("input", __assign({ onChange: function (e) {
                    setSelected(radioReference);
                    if (onChange)
                        onChange(e);
                }, className: classNames('nhsuk-radios__input', className), id: inputID, name: name, "aria-labelledby": children ? inputID + "--label" : undefined, "aria-describedby": hint ? inputID + "--hint" : undefined, checked: checked, defaultChecked: defaultChecked, ref: inputRef }, rest)),
            children ? (React.createElement(Label, __assign({ className: "nhsuk-radios__label", id: inputID + "--label", htmlFor: inputID }, labelProps), children)) : null,
            hint ? (React.createElement(Hint, __assign({ className: "nhsuk-radios__hint", id: inputID + "--hint" }, hintProps), hint)) : null),
        conditional && (shouldShowConditional || forceShowConditional) ? (React.createElement("div", __assign({ className: "nhsuk-radios__conditional", id: inputID + "--conditional" }, conditionalWrapperProps), conditional)) : null));
};
Radio.defaultProps = {
    type: 'radio',
};

var Radios = /** @class */ (function (_super) {
    __extends(Radios, _super);
    function Radios(props) {
        var rest = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            rest[_i - 1] = arguments[_i];
        }
        var _this = _super.apply(this, __spreadArrays([props], rest)) || this;
        _this.radioCount = 0;
        _this.radioReferences = [];
        _this.radioIds = {};
        _this.getRadioId = function (id, reference) {
            var idPrefix = _this.props.idPrefix;
            if (reference in _this.radioIds) {
                return _this.radioIds[reference];
            }
            _this.radioCount += 1;
            _this.radioIds[reference] = (idPrefix || id) + "-" + _this.radioCount;
            return _this.radioIds[reference];
        };
        _this.leaseReference = function () {
            var reference = generateRandomName();
            if (_this.radioReferences.includes(reference)) {
                return _this.leaseReference();
            }
            _this.radioReferences.push(reference);
            return reference;
        };
        _this.unleaseReference = function (reference) {
            _this.radioReferences = _this.radioReferences.filter(function (ref) { return ref !== reference; });
        };
        _this.setConditional = function (radioReference, hasConditional) {
            _this.setState(function (state) {
                var currentHasConditional = state.conditionalRadios.includes(radioReference);
                if (currentHasConditional && hasConditional === false) {
                    return __assign(__assign({}, state), { conditionalRadios: state.conditionalRadios.filter(function (ref) { return ref !== radioReference; }) });
                }
                if (!currentHasConditional && hasConditional === true) {
                    return __assign(__assign({}, state), { conditionalRadios: __spreadArrays(state.conditionalRadios, [radioReference]) });
                }
                return state;
            });
        };
        _this.setSelected = function (radioReference) {
            _this.setState({
                selectedRadio: radioReference,
            });
        };
        _this.resetRadioIds = function () {
            _this.radioCount = 0;
            _this.radioIds = {};
        };
        _this.state = {
            conditionalRadios: [],
            selectedRadio: '',
        };
        return _this;
    }
    Radios.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, rest = __rest(_a, ["children"]);
        return (React.createElement(FormGroup, __assign({ inputType: "radios" }, rest), function (_a) {
            var className = _a.className, inline = _a.inline, name = _a.name, id = _a.id, error = _a.error, restRenderProps = __rest(_a, ["className", "inline", "name", "id", "error"]);
            _this.resetRadioIds();
            var contextValue = {
                getRadioId: function (reference) { return _this.getRadioId(id, reference); },
                selectedRadio: _this.state.selectedRadio,
                setConditional: _this.setConditional,
                setSelected: _this.setSelected,
                leaseReference: _this.leaseReference,
                unleaseReference: _this.unleaseReference,
                name: name,
            };
            var containsConditional = _this.state.conditionalRadios.length > 0;
            return (React.createElement("div", __assign({ className: classNames('nhsuk-radios', { 'nhsuk-radios--inline': inline }, { 'nhsuk-radios--conditional': containsConditional }, className), id: id }, restRenderProps),
                React.createElement(RadiosContext.Provider, { value: contextValue }, children)));
        }));
    };
    Radios.defaultProps = {
        role: 'radiogroup',
    };
    Radios.Divider = Divider;
    Radios.Radio = Radio;
    return Radios;
}(PureComponent));

var ReviewDate = function (_a) {
    var className = _a.className, lastReviewed = _a.lastReviewed, nextReview = _a.nextReview, rest = __rest(_a, ["className", "lastReviewed", "nextReview"]);
    return (React.createElement("div", __assign({ className: classNames('nhsuk-review-date', className) }, rest),
        React.createElement("p", { className: "nhsuk-body-s" },
            lastReviewed ? "Page last reviewed: " + lastReviewed : null,
            lastReviewed && nextReview ? React.createElement("br", null) : null,
            nextReview ? "Next review due: " + nextReview : null)));
};

var Select = function (_a) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    return (React.createElement(FormGroup, __assign({ inputType: "select" }, rest), function (_a) {
        var className = _a.className, error = _a.error, restRenderProps = __rest(_a, ["className", "error"]);
        return (React.createElement("select", __assign({ className: classNames('nhsuk-select', { 'nhsuk-select--error': error }, className) }, restRenderProps), children));
    }));
};
var Option = function (_a) {
    var className = _a.className, rest = __rest(_a, ["className"]);
    return (React.createElement("option", __assign({}, rest)));
};
Select.Option = Option;

var SkipLink = /** @class */ (function (_super) {
    __extends(SkipLink, _super);
    function SkipLink(props) {
        var rest = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            rest[_i - 1] = arguments[_i];
        }
        var _this = _super.apply(this, __spreadArrays([props], rest)) || this;
        _this.handleHeadingBlur = function (event) {
            event.preventDefault();
            if (_this.firstHeadingElement) {
                _this.unfocusElement(_this.firstHeadingElement);
            }
        };
        _this.getFirstHeadingElement = function () {
            var allHeadings = document.getElementsByTagName('h1');
            if (allHeadings.length > 0) {
                return allHeadings[0];
            }
            return null;
        };
        _this.focusElement = function (element) {
            // Sometimes custom focus code can cause a loop of focus events
            // (especially in IE11), so check for attributes before performing
            // focus actions and DOM manipulation.
            if (!element.hasAttribute('tabIndex')) {
                element.setAttribute('tabIndex', '-1');
            }
            if (document.activeElement !== element) {
                element.focus();
            }
        };
        _this.unfocusElement = function (element) {
            if (element.hasAttribute('tabIndex'))
                element.removeAttribute('tabIndex');
        };
        _this.onClick = function (event) {
            var _a = _this.props, onClick = _a.onClick, focusTargetRef = _a.focusTargetRef, disableDefaultBehaviour = _a.disableDefaultBehaviour;
            if (disableDefaultBehaviour)
                event.preventDefault();
            if (focusTargetRef && focusTargetRef.current) {
                _this.focusElement(focusTargetRef.current);
            }
            else if (!disableDefaultBehaviour) {
                // Follow the default NHSUK Frontend behaviour, but go about it in a safer way.
                // https://github.com/nhsuk/nhsuk-frontend/blob/master/packages/components/skip-link/skip-link.js
                if (_this.firstHeadingElement)
                    _this.focusElement(_this.firstHeadingElement);
            }
            if (onClick) {
                event.persist();
                onClick(event);
            }
        };
        _this.firstHeadingElement = null;
        return _this;
    }
    SkipLink.prototype.componentDidMount = function () {
        // The standard NHSUK Frontend behaviour is to listen on the
        // blur event on the first heading element.
        this.firstHeadingElement = this.getFirstHeadingElement();
        if (this.firstHeadingElement) {
            this.firstHeadingElement.addEventListener('blur', this.handleHeadingBlur);
        }
    };
    SkipLink.prototype.componentWillUnmount = function () {
        if (this.firstHeadingElement) {
            this.firstHeadingElement.removeEventListener('blur', this.handleHeadingBlur);
        }
    };
    SkipLink.prototype.render = function () {
        var _a = this.props, className = _a.className, focusTargetRef = _a.focusTargetRef, disableDefaultBehaviour = _a.disableDefaultBehaviour, href = _a.href, rest = __rest(_a, ["className", "focusTargetRef", "disableDefaultBehaviour", "href"]);
        return (React.createElement("a", __assign({ className: classNames('nhsuk-skip-link', className), onClick: this.onClick, href: disableDefaultBehaviour ? undefined : href }, rest)));
    };
    SkipLink.defaultProps = {
        children: 'Skip to main content',
        href: '#maincontent',
        tabIndex: 0,
    };
    return SkipLink;
}(React.Component));

var SummaryListRow = function (_a) {
    var className = _a.className, rest = __rest(_a, ["className"]);
    return (React.createElement("div", __assign({ className: classNames('nhsuk-summary-list__row', className) }, rest)));
};
var SummaryListKey = function (_a) {
    var className = _a.className, rest = __rest(_a, ["className"]);
    return (React.createElement("dt", __assign({ className: classNames('nhsuk-summary-list__key', className) }, rest)));
};
var SummaryListValue = function (_a) {
    var className = _a.className, rest = __rest(_a, ["className"]);
    return (React.createElement("dd", __assign({ className: classNames('nhsuk-summary-list__value', className) }, rest)));
};
var SummaryListActions = function (_a) {
    var className = _a.className, rest = __rest(_a, ["className"]);
    return (React.createElement("dd", __assign({ className: classNames('nhsuk-summary-list__actions') }, rest)));
};
var SummaryList = function (_a) {
    var className = _a.className, noBorder = _a.noBorder, rest = __rest(_a, ["className", "noBorder"]);
    return (React.createElement("dl", __assign({ className: classNames('nhsuk-summary-list', { 'nhsuk-summary-list--no-border': noBorder }, className) }, rest)));
};
SummaryList.Row = SummaryListRow;
SummaryList.Key = SummaryListKey;
SummaryList.Value = SummaryListValue;
SummaryList.Actions = SummaryListActions;

var development = !process.env.NODE_ENV
    || process.env.NODE_ENV === 'development'
    || process.env.NODE_ENV === 'test';
function isDev() {
    return development;
}

var TableSectionTypes;
(function (TableSectionTypes) {
    TableSectionTypes["HEAD"] = "HEADER";
    TableSectionTypes["BODY"] = "BODY";
})(TableSectionTypes || (TableSectionTypes = {}));
var TableSectionContext = createContext(TableSectionTypes.HEAD);
var TableHead = function (_a) {
    var className = _a.className, children = _a.children, rest = __rest(_a, ["className", "children"]);
    return (React.createElement("thead", __assign({ className: classNames('nhsuk-table__head', className) }, rest),
        React.createElement(TableSectionContext.Provider, { value: TableSectionTypes.HEAD }, children)));
};
var TableBody = function (_a) {
    var className = _a.className, children = _a.children, rest = __rest(_a, ["className", "children"]);
    return (React.createElement("tbody", __assign({ className: classNames('nhsuk-table__body', className) }, rest),
        React.createElement(TableSectionContext.Provider, { value: TableSectionTypes.BODY }, children)));
};
var TableRow = function (_a) {
    var className = _a.className, rest = __rest(_a, ["className"]);
    return (React.createElement("tr", __assign({ className: classNames('nhsuk-table__row', className) }, rest)));
};
var TableCell = function (_a) {
    var className = _a.className, header = _a.header, rest = __rest(_a, ["className", "header"]);
    var sectionType = useContext(TableSectionContext);
    if (header !== undefined) {
        if (header === true) {
            return React.createElement("th", __assign({ className: classNames('nhsuk-table__header', className), scope: "col" }, rest));
        }
        return React.createElement("td", __assign({ className: classNames('nhsuk-table__cell', className) }, rest));
    }
    if (sectionType === TableSectionTypes.HEAD) {
        return React.createElement("th", __assign({ className: classNames('nhsuk-table__header', className), scope: "col" }, rest));
    }
    if (sectionType === TableSectionTypes.BODY) {
        return React.createElement("td", __assign({ className: classNames('nhsuk-table__cell', className) }, rest));
    }
    if (isDev()) {
        console.warn('TableCell used outside of TableHead or TableBody elements. Unable to determine section type from context.');
    }
    return React.createElement("td", __assign({ className: classNames('nhsuk-table__cell', className) }, rest));
};
var TablePanel = function (_a) {
    var className = _a.className, children = _a.children, heading = _a.heading, headingLevel = _a.headingLevel, headingProps = _a.headingProps, rest = __rest(_a, ["className", "children", "heading", "headingLevel", "headingProps"]);
    return (React.createElement("div", __assign({ className: classNames('nhsuk-table__panel-with-heading-tab', className) }, rest),
        heading ? (React.createElement(HeadingLevel, __assign({ className: "nhsuk-table__heading-tab" }, headingProps, { headingLevel: headingLevel }), heading)) : null,
        children));
};
TablePanel.defaultProps = {
    headingLevel: 'h3',
};
var Table = function (_a) {
    var className = _a.className, caption = _a.caption, children = _a.children, rest = __rest(_a, ["className", "caption", "children"]);
    return (React.createElement("div", { className: "nhsuk-table-responsive" },
        React.createElement("table", __assign({ className: classNames('nhsuk-table', className) }, rest),
            caption ? React.createElement("caption", { className: "nhsuk-table__caption" }, caption) : null,
            children)));
};
Table.Body = TableBody;
Table.Head = TableHead;
Table.Row = TableRow;
Table.Cell = TableCell;
Table.Panel = TablePanel;

var Textarea = function (props) { return (React.createElement(FormGroup, __assign({ inputType: "textarea" }, props), function (_a) {
    var className = _a.className, error = _a.error, rest = __rest(_a, ["className", "error"]);
    return (React.createElement("textarea", __assign({ className: classNames('nhsuk-textarea', { 'nhsuk-textarea--error': error }, className) }, rest)));
})); };

var LedeText = function (_a) {
    var className = _a.className, rest = __rest(_a, ["className"]);
    return (React.createElement("p", __assign({ className: classNames('nhsuk-lede-text', className) }, rest)));
};

var BodyText = function (_a) {
    var className = _a.className, rest = __rest(_a, ["className"]);
    return (React.createElement("p", __assign({ className: classNames('nhsuk-body', className) }, rest)));
};

var WarningCallout = function (_a) {
    var className = _a.className, label = _a.label, children = _a.children, labelProps = _a.labelProps, rest = __rest(_a, ["className", "label", "children", "labelProps"]);
    var _b = labelProps || {}, labelClassName = _b.className, restLabelProps = __rest(_b, ["className"]);
    return (React.createElement("div", __assign({ className: classNames('nhsuk-warning-callout', className) }, rest),
        label ? (React.createElement("h3", __assign({ className: classNames('nhsuk-warning-callout__label', labelClassName) }, restLabelProps), label)) : null,
        children));
};

var Clearfix = function (props) { return (React.createElement("div", __assign({ className: "nhsuk-u-clear" }, props))); };

var ReadingWidth = function (_a) {
    var className = _a.className, rest = __rest(_a, ["className"]);
    return (React.createElement("div", __assign({ className: classNames('nhsuk-u-reading-width', className) }, rest)));
};

export { ActionLink, ArrowLeft as ArrowLeftIcon, ArrowRightCircle as ArrowRightCircleIcon, ArrowRight as ArrowRightIcon, BackLink, BodyText, Breadcrumb, ButtonWrapper as Button, ButtonLink, CareCard, Checkboxes, ChevronLeft as ChevronLeftIcon, ChevronRight as ChevronRightIcon, Clearfix, Close as CloseIcon, Col, Container, ContentsList, Cross as CrossIcon, DateInput, Button as DefaultButton, Details, DoDontList, Emdash as EmdashIcon, ErrorMessage, ErrorSummary, Fieldset, Footer, Form, Header, Hero, Hint, Icons, Images, Input, InsetText, Label, LedeText, ListPanel, Minus as MinusIcon, NavAZ, Pagination, Panel$1 as Panel, Plus as PlusIcon, Promo, Radios, ReadingWidth, ReviewDate, Row, Search as SearchIcon, Select, SkipLink, SmallEmdash as SmallEmdashIcon, SummaryList, Table, Textarea, Tick as TickIcon, WarningCallout, useFormContext };
